import { inject, Injectable } from '@angular/core';
import { CacheMPKService } from './cache-mpk.service';
import { MPKeys } from '@lentau/mpk/shared/constants';
import { MpkFacade } from '@lentau/mpk/store';
import { UpdateMpkService } from './update-mpk.service';

@Injectable({
  providedIn: 'root',
})
export class InitMpkService {
  private cacheMPKService = inject(CacheMPKService);
  private mpkFacade = inject(MpkFacade);
  private updateMpkService = inject(UpdateMpkService);

  public init(): void {
    this.getCachedState();
    this.updateMpkService.getMPK();
  }

  public getCachedState(): void {
    const mpk: MPKeys = this.cacheMPKService.getInitDeliveryMode();
    this.mpkFacade.initMPK(mpk);
  }
}
